import { Link } from 'react-router-dom';

import { FOCO_VISIVEL } from 'utils/foco';

interface CabecalhoDeSecaoProps {
  id: string;
  sobretitulo?: string;
  titulo: string;
  subtitulo?: string;
  link?: { para: string; rotulo: string };
}

export const SETA = (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <path d="M5 12h14" />
    <path d="m13 6 6 6-6 6" />
  </svg>
);

/**
 * Título das seções do Feed, com o link "Ver todos" à direita. Sobretítulo e subtítulo são opcionais:
 * sem eles, o link fica na mesma linha do título (AJH-32).
 */
export default function CabecalhoDeSecao({ id, sobretitulo, titulo, subtitulo, link }: CabecalhoDeSecaoProps) {
  const descricao = [sobretitulo && `${id}-sobretitulo`, subtitulo && `${id}-subtitulo`].filter(Boolean).join(' ');

  return (
    <div className={`flex flex-wrap justify-between gap-4 ${sobretitulo || subtitulo ? 'items-end' : 'items-center'}`}>
      <div>
        {sobretitulo && (
          <p id={`${id}-sobretitulo`} className="m-0 mb-[5px] font-display text-[11px] font-bold uppercase tracking-[0.12em] text-brand-blue-dark">
            {sobretitulo}
          </p>
        )}
        {/* Parada de Tab da seção: o leitor lê o título e, como descrição, o sobretítulo e o subtítulo. */}
        <h2
          id={id}
          tabIndex={0}
          aria-describedby={descricao || undefined}
          className={`m-0 font-display text-[20px] font-bold leading-[1.2] text-brand-blue-dark ${FOCO_VISIVEL}`}
        >
          {titulo}
        </h2>
        {subtitulo && (
          <p id={`${id}-subtitulo`} className="m-0 mt-1 text-[13px] text-content">
            {subtitulo}
          </p>
        )}
      </div>
      {link && (
        <Link
          to={link.para}
          className={`flex items-center gap-2 whitespace-nowrap font-display text-[12px] font-bold uppercase tracking-[0.05em] text-brand-blue-dark hover:text-brand-blue-dark ${FOCO_VISIVEL}`}
        >
          {link.rotulo} {SETA}
        </Link>
      )}
    </div>
  );
}
